import { PaperBox } from "../../../../../components/Layout/PaperBox"
import { IDetalhePublicoCheques } from "../../../../../types/api/cadastros/detalhar-publico";
import { formatarValorMonetario } from "../../../../../helpers/masks";
import { DadoValorPrinter } from "../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import { Box, Link } from "@mui/material";
import { useState } from "react";
import DialogDetalhe from "./DialogDetalhe";

export const CardCheques = ({
    data
}: CardChequesProps) => {

    const [openDetalhe, setOpenDetalhe] = useState<boolean>(false)

    return (
        <>
            <PaperBox title="Cheques pré-datados" height={'100%'}>
                <Box display={'flex'} gap={2} flexWrap={'wrap'} justifyContent={'space-between'}>
                    <DadoValorPrinter titulo="Total cheques" valor={`${formatarValorMonetario(data.total_cheque)}`} alignValue="right" alignTitle="right" />
                    <DadoValorPrinter titulo="Total cheques devolvidos" valor={`${formatarValorMonetario(data.total_cheque_devolvido)}`} alignValue="right" alignTitle="right" />
                    <DadoValorPrinter titulo="Possui cheque devolvido anteriormente?" valor={`${data.possui_cheque_devolvido}`} />
                </Box>
                <Box display={'flex'} justifyContent={'flex-end'}>
                    {
                        (data.cheques || data.cheques_devolvidos) &&
                        <Link mt={1} onClick={() => setOpenDetalhe(true)} sx={{ cursor: 'pointer' }}>Ver detalhes</Link>
                    }
                </Box>
            </PaperBox>
            {
                openDetalhe &&
                <DialogDetalhe
                    {...{ data }}
                    open={openDetalhe}
                    handleClose={() => setOpenDetalhe(false)}
                />
            }
        </>
    )
}

interface CardChequesProps {
    data: IDetalhePublicoCheques
}
